module.exports = fox._r("images/btn_continue.png", __webpack_public_path__ + "images/btn_continue.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/btn_continue.png
// module id = 1023
// module chunks = 4